import { gql } from "@apollo/client";

export const GQL_OSSERVATORIO_TARI_DOCS = gql`
   query osservatorioTariDocs($comune_code_istat: String!, $anno: Int) {
      osservatorioTariDocs(comune_code_istat: $comune_code_istat, anno: $anno) {
         comune_code_istat
         anni {
            anno
            documenti {
               nome
               url
               ruolo
               numero_allegato
               tariffe {
                  non_domestiche
                  pagine_non_domestiche
                  domestiche
                  pagine_domestiche
               }
            }
         }
      }
   }
`;

export const GQL_OSSERVATORIO_TARI_TARIFFE = gql`
   query osservatorioTariTariffe($comune_code_istat: String!, $anno: Int!) {
      osservatorioTariTariffe(comune_code_istat: $comune_code_istat, anno: $anno) {
         comune_code_istat
         anno
         categorie {
            codice
            descrizione
            tariffa_fissa
            tariffa_variabile
            valida
            nota_mef
         }
      }
   }
`;

export const GQL_OSSERVATORIO_TARI_REGOLAMENTI = gql`
   query osservatorioTariRegolamenti($comune_code_istat: String!) {
      osservatorioTariRegolamenti(comune_code_istat: $comune_code_istat) {
         comune_code_istat
         in_vigore {
            anno
            regolamento {
               id_pubblicazione
               anno
               numero
               data_atto
            }
            modifiche
            articoli {
               tipo
               numero
               rubrica
               titolo
               gruppo
               testo
               abrogato
               pagina_inizio
               pagina_fine
               documento {
                  nome
                  url
               }
               modifiche
               da_aggiornare
            }
         }
         anni {
            anno
            regolamenti {
               id_pubblicazione
               numero
               data_atto
               data_pubblicazione
               note
               valido
               tipo_documento
               documenti {
                  nome
                  url
                  ruolo
                  numero_allegato
               }
            }
         }
      }
   }
`;
